import React from 'react'

const DefaultJsonFormContext = React.createContext({})
export default DefaultJsonFormContext
